import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { countries } from 'countries-list';

interface CountryOption {
  code: string;
  name: string;
}

@Component({
  selector: 'app-formly-country-multi-select',
  template: `
    <p-multiselect
      [options]="countryOptions"
      optionLabel="name"
      optionValue="code"
      [filter]="true"
      filterBy="name"
      [showClear]="!props.required"
      [appendTo]="props['appendTo'] || null"
      [placeholder]="props.placeholder ?? props.label ?? ''"
      [formControl]="formControl"
      [formlyAttributes]="field"
      display="chip"
      styleClass="w-full"
    >
      <ng-template let-country #item>
        <div class="flex items-center gap-2">
          <span
            class="fi fi-{{ country.code.toLowerCase() }} mr-2"
            style="font-size: 1.1rem;"
          ></span>
          <div>{{ country.name }}</div>
        </div>
      </ng-template>
    </p-multiselect>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyCountryMultiSelectComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  countryOptions: CountryOption[] = [];

  ngOnInit() {
    this.countryOptions = Object.entries(countries)
      .map(([code, c]) => ({ code, name: c.name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
